import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-report-breadcrumb-card',
  templateUrl: './helpbutton-report-breadcrumb-card.component.html',
  styleUrls: ['./helpbutton-report-breadcrumb-card.component.scss']
})
export class HelpbuttonReportBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
